export const getPhoneNumberErrorMessage = (phoneNumber) => {
    if (!phoneNumber || !phoneNumber.trim()) {
        return 'Please add a phone number including the country code (e.g. +1)';
    }
    if (!phoneNumber.startsWith('+')) {
        return 'All phone numbers should include a country code (e.g. +1)';
    }
    if (!/^[+]?[0-9]+$/.test(phoneNumber)) {
        return 'Invalid characters entered (E.164 format)';
    }
    return null;
};
